import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { CheckboxField } from '../../fields';
import { required } from '../../../utilities/validation';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

class RoleSelectorTermsAgreement extends React.Component {
    render() {
        const { handleSubmit, submitting, back, iAgree } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'terms.AgreementText'}
                            defaultMessage={
                                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec accumsan ultricies mi, at viverra lectus viverra a. Etiam viverra vulputate euismod. Praesent id feugiat sapien. Mauris mollis tristique sem, congue dictum enim laoreet nec. Praesent pulvinar felis et tempus sollicitudin. Phasellus pulvinar mauris non nunc aliquet laoreet. Proin a elementum metus, et sollicitudin eros. Phasellus tempor auctor erat in suscipit. Curabitur accumsan bibendum justo, et euismod libero tincidunt nec. Ut quis porttitor ipsum. Maecenas suscipit faucibus elit vitae cursus. Nam ullamcorper nibh vel ullamcorper viverra. Nam in quam sed mi fermentum ultricies vitae vel elit. Nulla mollis sodales elit sed iaculis.'
                            }
                        />
                    </div>
                    <div className="col-xs-12">
                        <Field name="iAgree" component={CheckboxField} validate={required} checked={iAgree === true} placeholder={messages.iAgree} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button className="wizard-forward btn btn-default pull-left" type="button" disabled={submitting} onClick={back}>
                            <FormattedMessage {...messages.cancel} />
                        </button>
                        <button className="wizard-forward btn btn-success pull-right" type="submit" disabled={submitting}>
                            <FormattedMessage {...messages.submit} />
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

RoleSelectorTermsAgreement.defaultProps = {
    handleSubmit: undefined,
    back: () => null
};
RoleSelectorTermsAgreement.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    back: PropTypes.func
};

RoleSelectorTermsAgreement = reduxForm({
    form: 'role-select-terms-agreement',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(RoleSelectorTermsAgreement);

const selector = formValueSelector('role-select-terms-agreement');
const mapStateToProps = state => ({
    iAgree: selector(state, 'iAgree') && selector(state, 'iAgree') === true
});

export default connect(mapStateToProps, null)(RoleSelectorTermsAgreement);



// WEBPACK FOOTER //
// ./src/components/roleSelector/components/termsAgreement.jsx